<template>
  <div>
    <van-search
      autocomplete="off"
      v-model="formData.code"
      name="code"
      @search="onSubmit"
      placeholder="请输入单据号进行查询"
    >
      <template #right-icon>
        <van-icon name="filter-o" @click="showFilterDialog" />
      </template>
    </van-search>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已显示全部"
      @load="getList(true)"
    >
      <div
        v-for="item in tableData"
        :key="item.id"
        class="container"
        @click="rowClick(item)"
      >
        <div class="title">采购单号:{{ item.code }}</div>
        <div class="content">
          <div class="left">
            <div class="item flex" v-for="el in columns" :key="el.key">
              <div class="label">{{ el.title }}</div>
              <div class="value">{{ item[el.key] }}</div>
            </div>
          </div>

          <div class="">
            <div
              :class="[
                {
                  color1: item.status == '0',
                  color2: item.status == '6',
                  color3: item.status == '3',
                },
                'status',
              ]"
            >
              {{ getText(item.status) }}
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <FilterDialog
      :visible="filterDialogVisible"
      @close="filterDialogVisible = false"
      @confirm="filterDialogConfirm"
    >
      <template slot="content"> </template>
    </FilterDialog>
  </div>
</template>
<script>
import { query } from "../../../service/api/purchase/return";
import {
  PURCHASE_ORDER_STATUS,
  getTextByValue,
} from "../../../utils/constants";
import FilterDialog from "../../../components/filterDialog.vue";
export default {
  name: "index",
  components: {
    FilterDialog,
  },
  data() {
    return {
      filterDialogVisible: false,
      loading: false,
      finished: false,
      columns: [
        {
          field: "supplierName",
          title: "供应商",
          key: "supplierName",
        },
        {
          field: "createTime",
          title: "采购时间",
          key: "createTime",
        },
        { field: "createBy", title: "采购人", key: "createBy" },
        {
          field: "totalAmount",
          width: 60,
          title: "采购总金额",
          key: "totalAmount",
        },
      ],
      tableData: [],
      totalCount: 0,
      pageIndex: 1,
      pageSize: 20,
      totalPage: 1,
      formData: {},
      key: "",
      showDatePicker: false,
    };
  },
  computed: {
    statusColumns() {
      return PURCHASE_ORDER_STATUS;
    },
  },
  mounted() {
    this.onSubmit();
    localStorage.setItem("purchaseReturning", "{}");
    localStorage.setItem("orderDetailType", "");
  },
  methods: {
    statusClass(row) {
      return row.status == "0"
        ? "color1"
        : row.status == "6"
        ? "color2"
        : "color3";
    },
    showFilterDialog() {
      this.filterDialogVisible = true;
    },
    filterDialogConfirm(form) {
      this.filterDialogVisible = false;
      this.formData = { ...form };
      this.pageIndex = 1;
      this.getList();
    },
    getText(status) {
      return getTextByValue(PURCHASE_ORDER_STATUS, status);
    },
    rowClick(row) {
      this.$router.push({
        path: "/purchase/returnDetail/" + row.id,
      });
    },
    onSubmit() {
      this.pageIndex = 1;
      this.getList();
    },
    getList(load) {
      if (load) {
        this.pageIndex++;
      }
      this.loading = true;
      const params = {
        ...this.formData,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      query(params)
        .then((res) => {
          this.finished = false;
          this.loading = false;
          if (load) {
            this.tableData = this.tableData.concat(res.data.datas);
          } else {
            this.tableData = res.data.datas;
          }
          this.totalCount = res.data.totalCount;
          this.totalPage = res.data.totalPage;
          if (this.pageIndex >= this.totalPage) {
            this.finished = true;
          }
        })
        .catch(() => {
          this.loading = false;
          this.finished = true;
        });
    },
  },
};
</script>
<style lang="less" scoped>
* {
  touch-action: pan-y;
}
.van-cell {
  padding: 5px 2px 2px 5px !important;
}
.container {
  margin-top: 5px;
  padding: 10px 0 10px 10px;
  background-color: #fff;
  .title {
    font-size: 15px;
    font-weight: 500;
  }
  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    font-size: 14px;
    padding: 0px;
    .left {
      flex: 5;
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        .label {
          font-size: 14px;
          color: #333;
        }
        .value {
          font-size: 14px;
          color: #999;
        }
      }
    }
    .status {
      width: 90px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      flex: 2;
      margin-left: 20px;
      border-radius: 13px 0 0 13px;
      color: #fff;
      overflow: hidden;
      font-size: 14px;
    }
    .color1 {
      background: linear-gradient(83deg, #333, #858585);
    }
    .color2 {
      background: linear-gradient(83deg, red, #bfa98c);
    }
    .color3 {
      background: linear-gradient(83deg, #4c9673, #98bf8c);
    }
  }
}
::v-deep .van-list {
  height: calc(100vh - 7rem);
  overflow: auto;
}
</style>
